import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=bf1db5d0&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf1db5d0')) {
      api.createRecord('bf1db5d0', component.options)
    } else {
      api.reload('bf1db5d0', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=bf1db5d0&", function () {
      api.rerender('bf1db5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KWZhCM6oj2KV/JS/comp/ImgFallback.vue"
export default component.exports